<template>
  <div id="product-info-container">
    <VcWidget class="product-info" size="lg">
      <div class="product-info__container">
        <div class="product-info__side">
          <ImageGallery :images="product.images"> </ImageGallery>

          <ProductVideos class="product-info__videos" :videos="product.videos" />
        </div>

        <div class="product-info__print">
          <VcImage :src="product.imgSrc" class="product-info__print-img border-none" />
        </div>

        <div v-if="model?.blocks?.length" class="product-info__content">
          <VcTypography tag="h1" class="product-name">{{ product.name }}</VcTypography>
          <VcTypography tag="h2" class="product-motto">{{ getProductProperty("moto") }}</VcTypography>
          <VcTypography tag="h3" class="product-submotto">{{ getProductProperty("submoto") }}</VcTypography>
          <VcMarkdownRender :src="product?.description?.content || ''" class="product-description" />
        </div>
      </div>
    </VcWidget>
  </div>
</template>

<script setup lang="ts">
import { ImageGallery, ProductVideos } from "@/shared/catalog";
import type { PageContent } from "../types";
import type { Product } from "@/core/api/graphql/types";

interface IProps {
  product: Product;
  model: PageContent;
}

const props = defineProps<IProps>();

const getProductProperty = (propertyName: string, index: number = 0): string | undefined => {
  const properties = props.product?.properties?.filter((property) => property.name === propertyName) || [];
  const value = properties[index]?.value;
  return typeof value === "string" ? value : undefined;
};
</script>

<style lang="scss">
#product-info-container {
  .product-info {
    &__container {
      @apply flex flex-col lg:flex-row lg:gap-18 print:flex-row print:gap-4 sm:py-4 lg:px-0 md:px-0 xl:px-0;
    }

    &__side {
      @apply flex-none lg:w-80 xl:w-[27.5rem] 2xl:w-[30rem] print:hidden;
    }

    &__videos {
      @apply mt-8 lg:mt-3;
    }

    &__print {
      @apply hidden aspect-square w-40 flex-none print:block;
    }

    &__print-img {
      @apply w-full rounded border;
    }

    &__content {
      @apply mt-5 flex flex-col gap-3 lg:mt-0 lg:grow print:mt-5 print:grow;
    }

    .product-description {
      font-size: 16px;
      font-weight: 500;
      line-height: 22.5px;
    }
  }
}
</style>
